import styled from 'styled-components'
import { tokens } from '@arvoreeducacao/bonsai-ds'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${tokens.spacing.verticalMedium};
  padding: ${tokens.spacing.verticalSmall} 0;
`

export const Intro = styled.p`
  font-size: ${tokens.fontSize.medium};
  color: ${tokens.colors.dark5};
  margin: 0;
`

export const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: ${tokens.spacing.verticalXsmall};
`

export const Item = styled.li`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: ${tokens.spacing.verticalXsmall} 0;
  border-bottom: 1px solid ${tokens.colors.dark1};

  &:last-child {
    border-bottom: none;
  }
`

export const Phrase = styled.span`
  font-size: ${tokens.fontSize.medium};
  font-weight: ${tokens.fontWeights.bold};
  color: ${tokens.colors.dark5};
`

export const Description = styled.span`
  font-size: ${tokens.fontSize.small};
  color: ${tokens.colors.dark3};
`

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${tokens.spacing.verticalXsmall};
  margin-top: ${tokens.spacing.verticalSmall};
`
